module.exports = __webpack_public_path__ + "static/media/active_video_thumb5.e9c85c63.png";